import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-nineteen',
  templateUrl: './home-nineteen.component.html',
  styleUrls: ['./home-nineteen.component.scss']
})
export class HomeNineteenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
